import { SidebarProvider } from '@/components/ui/sidebar';

import { GlobalAIAssistant } from '@/features/ai-assistant/components/GlobalAIAssistant';
import AppSidebar from '@/layouts/AppSidebar';
import { useUserStore } from '@/stores/userStore';
import { MainContent } from './components/MainContent';

/** 允许显示 AI 助手入口的组织 ID */
const AI_ASSISTANT_ALLOWED_COMPANY_ORG_IDS = [2, 5];

/**
 * 基础布局组件
 * 提供侧边栏导航、面包屑导航和主题切换功能
 */
export default function BasicLayout() {
  const companyOrgId = useUserStore((state) => state.userInfo?.team?.companyOrgId);
  const canShowAIAssistant =
    companyOrgId !== undefined && AI_ASSISTANT_ALLOWED_COMPANY_ORG_IDS.includes(companyOrgId);

  return (
    <SidebarProvider>
      <AppSidebar />
      <MainContent />
      {/** AI 助手入口 */}
      {canShowAIAssistant ? <GlobalAIAssistant /> : null}
    </SidebarProvider>
  );
}
